import { ArrowRight } from "lucide-react";
import { useIdentity } from "@/features/identity/hooks/useIdentity";

export function WelcomeStep({ onNext }) {
  const { profile } = useIdentity();
  const firstName = profile.full_name?.split(/\s+/)[0];
  return (
    <section data-testid="onboarding-step-welcome" className="mw-rise">
      <p className="mw-eyebrow">Welcome</p>
      <h1 className="mt-3 font-serif text-4xl tracking-tight sm:text-6xl">Welcome to MetWorth{firstName ? `, ${firstName}` : ""}.</h1>
      <p className="mt-6 max-w-xl text-base leading-relaxed text-muted-foreground sm:text-lg">
        In eight steps you'll set up your professional identity, design your digital business card and public profile, then publish. Everything saves as you go.
      </p>
      <button type="button" onClick={onNext} data-testid="onboarding-start-button" className="mw-btn mw-btn-primary mt-12">
        Begin <ArrowRight className="h-4 w-4" />
      </button>
    </section>
  );
}
